document.addEventListener('DOMContentLoaded', function () {
  function initPraishSizeGuide(scope) {
    const productDetailsList = (scope || document).querySelectorAll('.product-details[data-product-id]');

    productDetailsList.forEach(function (productDetails) {
      if (productDetails.dataset.sizeGuideReady === 'true') return;
      productDetails.dataset.sizeGuideReady = 'true';

      const productId = productDetails.dataset.productId;
      const drawer = document.getElementById(`PraishSizeGuideDrawer-${productId}`);
      const overlay = document.getElementById(`PraishSizeGuideOverlay-${productId}`);
      const dataScript = document.getElementById(`PraishSizeChartData-${productId}`);

      if (!drawer || !overlay || !dataScript) return;

      const tableHead = drawer.querySelector('.praish-size-guide-table thead');
      const tableBody = drawer.querySelector('.praish-size-guide-table tbody');
      const unitButtons = drawer.querySelectorAll('.praish-unit-btn');

      let chartData = null;
      let activeUnit = 'in';

      try {
        chartData = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error('Invalid size chart JSON:', error);
        return;
      }

      function formatNumber(num) {
        const rounded = Math.round(num * 10) / 10;
        return Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
      }

      function convertValue(value, fromUnit, toUnit) {
        if (typeof value !== 'number') return value;
        if (fromUnit === toUnit) return value;
        if (fromUnit === 'in' && toUnit === 'cm') return value * 2.54;
        if (fromUnit === 'cm' && toUnit === 'in') return value / 2.54;
        return value;
      }

      function renderTable(unit) {
        if (!chartData || !chartData.columns || !chartData.rows) return;

        const baseUnit = chartData.unit || 'in';
        tableHead.innerHTML = '';
        tableBody.innerHTML = '';

        const headRow = document.createElement('tr');

        chartData.columns.forEach(function (column, index) {
          const th = document.createElement('th');
          th.textContent = index === 0 ? column : `${column} (${unit.toUpperCase()})`;
          headRow.appendChild(th);
        });

        tableHead.appendChild(headRow);

        chartData.rows.forEach(function (row) {
          const tr = document.createElement('tr');

          row.forEach(function (cell, index) {
            const td = document.createElement('td');

            if (index === 0) {
              td.textContent = cell;
            } else {
              const numericValue = typeof cell === 'number' ? cell : parseFloat(cell);
              const converted = convertValue(numericValue, baseUnit, unit);
              td.textContent = formatNumber(converted);
            }

            tr.appendChild(td);
          });

          tableBody.appendChild(tr);
        });
      }

      function openDrawer() {
        drawer.classList.add('active');
        overlay.classList.add('active');
        

        document.querySelectorAll(`[aria-controls="PraishSizeGuideDrawer-${productId}"]`).forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'true');
        });
      }

      function closeDrawer() {
        drawer.classList.remove('active');
        overlay.classList.remove('active');
        

        document.querySelectorAll(`[aria-controls="PraishSizeGuideDrawer-${productId}"]`).forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'false');
        });
      }

      function createTrigger(className, text) {
        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = className;
        trigger.setAttribute('aria-haspopup', 'dialog');
        trigger.setAttribute('aria-controls', `PraishSizeGuideDrawer-${productId}`);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.textContent = text || 'Size Guide';
        trigger.addEventListener('click', openDrawer);
        return trigger;
      }

      const priceBlock =
        productDetails.querySelector('.price') ||
        productDetails.querySelector('[data-testid*="price"]') ||
        productDetails.querySelector('.product-price') ||
        productDetails.querySelector('.price-block');

      if (priceBlock && !productDetails.querySelector('.praish-price-guide-row')) {
        const row = document.createElement('div');
        row.className = 'praish-price-guide-row';

        priceBlock.parentNode.insertBefore(row, priceBlock);
        row.appendChild(priceBlock);

        const trigger = createTrigger('praish-size-guide-trigger', 'Size Guide');
        row.appendChild(trigger);
      }

      const accordionCandidates = productDetails.querySelectorAll('button, summary, .accordion__title, .accordion summary, .accordion button');
      accordionCandidates.forEach(function (node) {
        const text = (node.textContent || '').trim().toLowerCase();
        if (text === 'size guide' || text.includes('size guide')) {
          node.addEventListener('click', function (event) {
            event.preventDefault();
            openDrawer();
          });
        }
      });

      unitButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          unitButtons.forEach(function (btn) {
            btn.classList.remove('active');
          });

          button.classList.add('active');
          activeUnit = button.dataset.unit;
          renderTable(activeUnit);
        });
      });

      overlay.addEventListener('click', closeDrawer);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer.classList.contains('active')) {
          closeDrawer();
        }
      });

      renderTable(activeUnit);
    });
  }

  initPraishSizeGuide(document);

  document.addEventListener('shopify:section:load', function (event) {
    initPraishSizeGuide(event.target);
  });
});